import { domStart } from "vnet-dom/domStart";
domStart();